import { createSlotRecipe } from './runtime.js';

const radioCardConfig = {"name":"radioCard","slots":["root","label","description"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const radioCard = /* @__PURE__ */ createSlotRecipe(radioCardConfig)